import React from 'react';
import {
  InlineWidget as CalendlyInlineWidget,
  useCalendlyEventListener,
} from 'react-calendly';
import sessionsService from '_services/sessionsService';
import { getCurrentTimeZone } from 'utils/moment';
import { ProfileAdvisor, ProfileSBOInfo } from '_types/profile.interface';
import CrossIcon from 'app/components/Icons/CrossIcon';
import Button from 'app/components/Button';
import clsx from 'clsx';

interface StepCalendlyProps {
  calendlyLink: string;
  sboInfo: ProfileSBOInfo;
  handleClose: () => void;
}

const StepCalendly: React.FC<StepCalendlyProps> = ({
  calendlyLink,
  sboInfo,
  handleClose,
}) => {
  if (!calendlyLink) {
    return <div style={{ padding: 32 }}>Select a time first.</div>;
  }

  return (
    <>
      <Button
        type="btn"
        btnLook="filled"
        size="medium"
        onClick={handleClose}
        className={clsx('modal_close_button', { show: true })}
      >
        <CrossIcon />
      </Button>
      <CalendlyInlineWidget
        url={calendlyLink}
        styles={{
          height: '100%',
          width: '100%',
        }}
        prefill={{
          email: sboInfo?.email || '',
          firstName: sboInfo?.firstName || '',
          lastName: sboInfo?.lastName || '',
          name: `${sboInfo?.firstName} ${sboInfo?.lastName}` || '',
        }}
      />
    </>
  );
};

export default StepCalendly;
